import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "tab-bar"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_tabs, {
    activeKey: $setup.activeKeyRef,
    "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => $setup.activeKeyRef = $event),
    type: "editable-card",
    "tab-position": "top",
    "hide-add": true,
    "destroy-inactive-tab-pane": true,
    centered: false,
    onChange: $setup.handleTabChanged,
    onEdit: $setup.handleTabEdit
  }, {
    leftExtra: _withCtx(() => [_renderSlot(_ctx.$slots, "leftExtra")]),
    rightExtra: _withCtx(() => [_renderSlot(_ctx.$slots, "rightExtra")]),
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.items, item => {
      return _openBlock(), _createBlock(_component_a_tab_pane, {
        key: item.path ?? '',
        tab: item.title,
        closable: item.closable ?? true
      }, null, 8, ["tab", "closable"]);
    }), 128))]),
    _: 3
  }, 8, ["activeKey", "onChange", "onEdit"])]);
}